import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { graphql, compose } from 'react-apollo'

import PropTypes from 'prop-types'

import classNames from 'classnames'
import moment from 'moment'

import _ from 'lodash'

import { getLatLngByAddress, geoSuggestToLocation, getPlaceInfoById } from './../../libs/utils'

import { validateRequired } from './../../libs/validation'
import { NotificationManager } from 'react-notifications'

import { TextInput } from '../UI'
import PhotoSlider from './../PhotoSlider'
import Activity from './Activity'
import Lodging from './Lodging'
import Flight from './Flight'
import CarRental from './CarRental'
import Train from './Train'
import Transportation from './Transportation'
import Info from './Info'

import * as defaultForm from './DefaultForms'

import config from './../../config'

import DELETE_FILE_QUERY from './../../graphql/DeleteFile.graphql'
import queries from './../../graphql/Event'
import CREATE_POI_QUERY from './../../graphql/CreatePOI.graphql'
import LINK_EVENT from './../../graphql/TripPlanner/LinkItineraryDayAndContentEvent.graphql'
import UNLINK_EVENT from './../../graphql/TripPlanner/UnLinkItineraryDayAndContentEvent.graphql'

const TRANSPORTATION = ['TransportationCategory', 'CarRental', 'Transportation', 'Train']

export const defaultDate = moment('2000-01-01').startOf('day')

const google = window.google

class Event extends Component {
  static propTypes = {
    deleteFile: PropTypes.func,
    createActivity: PropTypes.func,
    createFlight: PropTypes.func,
    createInfo: PropTypes.func,
    createLodging: PropTypes.func,
    createTransportation: PropTypes.func,
    updateActivity: PropTypes.func,
    updateFlight: PropTypes.func,
    updateInfo: PropTypes.func,
    updateLodging: PropTypes.func,
    updateTransportation: PropTypes.func,
    deleteContentPOI: PropTypes.func,
    isFluid: PropTypes.bool,
    onSave: PropTypes.func,
    t: PropTypes.func,
    dates: PropTypes.array,
    event: PropTypes.object,
    initialDay: PropTypes.number,
    POIData: PropTypes.object
  }

  static defaultProps = {
    isFluid: false,
    dates: []
  }

  constructor(props) {
    super(props)
    this.state = {
      isSubCategoryVisible: false,
      photos: [],
      selectedPhotos: [null, null, null],
      place: '',
      location: '',
      fileName: '',
      showFileLoader: false,
      additionalInfo: {},
      type: '',
      subType: '',
      form: {
        type: '',
        title: '',
        docsIds: [],
        photosIds: []
      },
      isPoi: !!this.props.POIData
    }
  }

  componentWillMount() {
    const { event } = this.props

    if (event) {
      this.onCategoryChange(event.type, false, () => {
        const form = this.form.getWrappedInstance()
        const daysState = {}

        const startDate = moment(event.startDate)
        const endDate = moment(event.endDate)

        switch (form.state.type) {
          case 'Activity':
          case 'Info':
            {
              daysState.time = startDate.clone()
              daysState.duration = endDate.diff(startDate, 'minutes')
              daysState.date = startDate.clone().startOf('day')
            }
            break
          case 'Lodging':
            {
              daysState.checkInDate = startDate.clone().startOf('day')
              daysState.checkInTime = startDate.clone()
              daysState.checkOutDate = endDate.clone().startOf('day')
              daysState.checkOutTime = endDate.clone()
            }
            break
          case 'Transportation':
          case 'Flight':
            {
              daysState.departureDate = startDate.clone().startOf('day')
              daysState.departureTime = startDate.clone()
              daysState.arrivalDate = endDate.clone().startOf('day')
              daysState.arrivalTime = endDate.clone()
            }
            break
        }

        form.setState(daysState)

        switch (form.state.type) {
          case 'Activity':
          case 'Lodging':
          case 'Info':
            {
              const placeId = _.get(event, 'eventPois[0].contentPOI.place.googleId')

              if (placeId) {
                this.onPlaceSelect(_.get(event, 'eventPois[0].contentPOI.title', ''), placeId)
              }
            }
            break
          case 'Transportation':
            {
              const departure = _.get(event, 'EventDetails.TransportationDetails.departure')
              const arrival = _.get(event, 'EventDetails.TransportationDetails.arrival')

              if (departure) {
                form.setState({ departure })
              }

              if (arrival) {
                form.setState({ arrival })
              }
            }
            break
          case 'Flight':
            {
              const departure = _.get(event, 'EventDetails.FlightDetail.departureAirport.name')
              const arrival = _.get(event, 'EventDetails.FlightDetail.arrivalAirport.name')

              if (departure) {
                form.setState({ departure })
              }

              if (arrival) {
                form.setState({ arrival })
              }
            }
            break
        }

        this.onFormFieldChange('title', event.title)

        if (event.startDate) {
          this.onFormFieldChange('startDate', moment(event.startDate).toISOString())
        }

        if (event.endDate) {
          this.onFormFieldChange('endDate', moment(event.endDate).toISOString())
        }

        if (_.has(event, 'contentPOIs[0]')) {
          const poiCopy = _.cloneDeep(event.eventPois[0].contentPOI)

          if (!poiCopy.website) {
            poiCopy.website = ''
          }

          this.onFormFieldChange('eventPois[0].contentPOI', poiCopy)
        }

        if (event.hasOwnProperty('description')) {
          this.onFormFieldChange('description', event.description || '')
        }

        if (event.hasOwnProperty('price')) {
          this.onFormFieldChange('price', +event.price)
        }

        if (event.hasOwnProperty('currency')) {
          this.onFormFieldChange('currency', event.currency || 'USD')
        }

        if (Array.isArray(event.photos)) {
          this.onFormFieldChange('photosIds', event.photos.map(photo => photo.id))
        }

        if (Array.isArray(event.docs)) {
          this.onFormFieldChange('docsIds', event.docs.map(doc => doc.id))
        }

        if (_.has(this.state.form, 'EventDetails.confirmationCode')) {
          this.onFormFieldChange('EventDetails.confirmationCode', _.get(event, 'EventDetails.confirmationCode', ''))
        }

        if (_.has(this.state.form, 'EventDetails.bookedThrough')) {
          this.onFormFieldChange('EventDetails.bookedThrough', _.get(event, 'EventDetails.bookedThrough', ''))
        }

        if (_.has(this.state.form, 'EventDetails.FlightDetail.airline')) {
          this.onFormFieldChange('EventDetails.FlightDetail.airline', _.get(event, 'EventDetails.FlightDetail.airline'))
        }

        if (_.has(this.state.form, 'EventDetails.FlightDetail.flightNumber')) {
          this.onFormFieldChange('EventDetails.FlightDetail.flightNumber', _.get(event, 'EventDetails.FlightDetail.flightNumber'))
        }

        if (_.has(this.state.form, 'EventDetails.FlightDetail.terminal')) {
          this.onFormFieldChange('EventDetails.FlightDetail.terminal', _.get(event, 'EventDetails.FlightDetails.terminal'))
        }

        if (_.has(this.state.form, 'EventDetails.FlightDetail.gateNumber')) {
          this.onFormFieldChange('EventDetails.FlightDetail.gateNumber', _.get(event, 'EventDetails.FlightDetail.gateNumber'))
        }

        if (_.has(this.state.form, 'EventDetails.transportationDetails.carrier')) {
          this.onFormFieldChange(
            'EventDetails.transportationDetails.carrier',
            _.get(event, 'EventDetails.transportationDetails.carrier', '')
          )
        }

        const state = {
          selectedPhotos: []
        }

        state.fileName = _.get(event, 'docs[0].name', '')
        state.photos = [...this.state.photos, ...event.photos]
        state.selectedPhotos = _.cloneDeep(event.photos).map(photo => {
          photo.isDefault = false

          if (event.defaultPhoto) {
            photo.isDefault = event.defaultPhoto.id === photo.id
          }

          return photo
        })

        state.selectedPhotos.push(...new Array(3 - event.photos.length).fill(null))
        this.setState(_.cloneDeep(state))
      })
    }
  }

  onCategoryChange(category, isSub, cb) {
    const { dates, initialDay } = this.props

    let form = {}

    if (defaultForm[category]) {
      form = _.cloneDeep(defaultForm[category])
    }

    form = {
      ...form,
      type: category,
      docsIds: []
    }

    if (dates[initialDay]) {
      if (dates[initialDay].dayOfTrip) {
        form.startDate = moment(dates[initialDay].dayOfTrip)
          .startOf('day')
          .toISOString()
        form.endDate = moment(dates[initialDay].dayOfTrip)
          .startOf('day')
          .toISOString()
      } else {
        form.startDate = defaultDate.clone().toISOString()
        form.endDate = defaultDate.clone().toISOString()
      }
    }

    if (isSub) {
      form.title = this.state.form.title
    } else {
      form.title = 'a'
    }

    let isSubCategoryVisible
    let type
    let subType

    if (TRANSPORTATION.indexOf(category) === -1) {
      type = category
      subType = ''
      isSubCategoryVisible = false
    } else {
      type = 'TransportationCategory'
      subType = category
      isSubCategoryVisible = true
    }

    this.setState(
      {
        selectedPhotos: [null, null, null],
        photos: [],
        place: '',
        location: '',
        fileName: '',
        isSubCategoryVisible,
        type,
        subType,
        form
      },
      async () => {
        if (this.props.POIData) {
          let placeInfo
          let locationInfo
          try {
            placeInfo = await getPlaceInfoById(this.props.POIData.place.googleId)
            locationInfo = await getPlaceInfoById(this.props.POIData.location.googleId)
          } catch (err) {
            NotificationManager.error(err.message, 'Error', 5000)
          }
          this.setState(
            {
              place: placeInfo.name,
              location: locationInfo.name
            },
            () => {
              const title = _.get(placeInfo, 'name', '')
              const placeCopy = _.cloneDeep(placeInfo)

              placeCopy.location = {
                lat: placeInfo.geometry.location.lat(),
                lng: placeInfo.geometry.location.lng()
              }

              const formattedPlace = this.formatPlaceDetails(placeCopy)
              this.onFormFieldChange('eventPois[0].contentPOI.title', title)
              this.onFormFieldChange('eventPoi.contentPOI.website', _.get(placeCopy, 'website'))
              this.onFormFieldChange('eventPoi.cotentPOI.place', _.cloneDeep(formattedPlace))
              this.onFormFieldChange('description', _.cloneDeep(this.props.POIData.description))
              this.onFormFieldChange('eventPois[0].contentPOI.place.description', _.cloneDeep(this.props.POIData.description))
              if (Array.isArray(this.props.POIData.photos)) {
                this.setState(
                  {
                    selectedPhotos: _.cloneDeep([
                      ...this.props.POIData.photos,
                      ...new Array(3 - this.props.POIData.photos.length).fill(null)
                    ])
                  },
                  () => {}
                )
              }
              if (Array.isArray(placeInfo.photos) && placeInfo.photos.length) {
                this.setState({
                  photos: _.cloneDeep([...this.state.photos, ...placeInfo.photos])
                })
              }
            }
          )
        }

        if (typeof this.props.initialDay === 'number') {
          const form = this.form && this.form.getWrappedInstance()

          let date

          if (this.props.dates[this.props.initialDay].dayOfTrip) {
            date = moment(this.props.dates[this.props.initialDay].dayOfTrip)
          } else {
            date = defaultDate.clone().add(this.props.initialDay, 'days')
          }

          if (form) {
            switch (form.state.type) {
              case 'Activity':
              case 'Info':
                {
                  form.setState({
                    date: date.clone(),
                    time: date.clone()
                  })
                }
                break
              case 'Lodging':
                {
                  form.setState({
                    checkInDate: date.clone(),
                    checkInTime: date.clone(),
                    checkOutDate: date.clone(),
                    checkOutTime: date.clone()
                  })
                }
                break
              case 'Transportation':
              case 'Flight':
                {
                  form.setState({
                    departureDate: date.clone(),
                    departureTime: date.clone(),
                    arrivalDate: date.clone(),
                    arrivalTime: date.clone()
                  })
                }
                break
            }
          }
        }

        if (isSub) {
          if (_.isFunction(cb)) {
            cb()
          }
        } else {
          this.titleInput.validate()
          this.onFormFieldChange('title', '', () => {
            if (_.isFunction(cb)) {
              cb()
            }
          })
        }
      }
    )
  }

  onPlaceChange(place) {
    this.setState({ place })
  }

  onPlaceSelect(place, placeId) {
    this.setState({ place }, async () => {
      let placeInfo

      try {
        placeInfo = await getPlaceInfoById(placeId)
      } catch (err) {
        NotificationManager.error(err.message, 'Error', 5000)
      }

      this.setState(
        {
          location: placeInfo.formatted_address
        },
        () => {
          const title = _.get(placeInfo, 'name', '')
          const placeCopy = _.cloneDeep(placeInfo)

          placeCopy.location = {
            lat: placeInfo.geometry.location.lat(),
            lng: placeInfo.geometry.location.lng()
          }

          const formattedPlace = this.formatPlaceDetails(placeCopy)

          this.onFormFieldChange('contentPOIs[0].title', title)
          this.onFormFieldChange('contentPOIs[0].website', _.get(placeCopy, 'website'))
          this.onFormFieldChange('contentPOIs[0].place', _.cloneDeep(formattedPlace))
          this.onFormFieldChange('contentPOIs[0].location', _.cloneDeep(formattedPlace))

          if (Array.isArray(placeInfo.photos) && placeInfo.photos.length) {
            this.setState({
              photos: _.cloneDeep([...this.state.photos, ...placeInfo.photos])
            })
          }
        }
      )
    })
  }

  onLocationChange(location) {
    this.setState({ location })
  }

  onLocationSelect(location, placeId, cb) {
    this.setState({ location }, () => {
      getLatLngByAddress(location).then(({ center, additionalInfo }) => {
        const service = new google.maps.places.PlacesService(document.createElement('div'))

        service.getDetails(
          {
            placeId: placeId || additionalInfo.place_id
          },
          (place, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              place.location = center

              const formattedPlaceDetails = this.formatPlaceDetails(place)

              this.onFormFieldChange('contentPOIs[0].location', formattedPlaceDetails, () => {
                if (_.isFunction(cb)) {
                  cb(formattedPlaceDetails)
                }
              })
            }
          }
        )
      })
    })
  }

  onFileUpload() {
    if (this.attachmentInput.files && this.attachmentInput.files.length) {
      const body = new FormData()

      this.setState(
        {
          showFileLoader: true
        },
        async () => {
          if (Array.isArray(this.state.form.docsIds) && this.state.form.docsIds.length) {
            try {
              await this.props.deleteFile({
                variables: {
                  id: this.state.form.docsIds[0]
                }
              })
            } catch (err) {
              NotificationManager.error(err.message, 'Error', 5000)
            }
          }

          body.append('data', this.attachmentInput.files[0])

          let res
          let file

          try {
            res = await fetch(config.fileAPI, {
              method: 'POST',
              body
            })
          } catch (err) {
            NotificationManager.error(err.message, 'Error', 5000)
          }

          try {
            file = await res.json()
          } catch (err) {
            NotificationManager.error(err.message, 'Error', 5000)

            this.setState({
              showFileLoader: false
            })
          }

          this.onFormFieldChange('docsIds', [file.id], () => {
            this.setState({
              fileName: this.attachmentInput.files[0].name,
              showFileLoader: false
            })
          })
        }
      )
    }
  }

  onFileRemove(event) {
    event.stopPropagation()

    const { form } = this.state

    if (Array.isArray(form.docsIds) && form.docsIds.length) {
      this.setState(
        {
          showFileLoader: true
        },
        async () => {
          try {
            await this.props.deleteFile({
              variables: {
                id: form.docsIds[0]
              }
            })
          } catch (err) {
            NotificationManager.error(err.message, 'Error', 5000)

            this.setState({
              showFileLoader: false
            })
          }

          this.setState(
            {
              fileName: ''
            },
            () => {
              this.onFormFieldChange('docsIds', [], () => {
                this.setState({
                  showFileLoader: false
                })
              })
            }
          )
        }
      )
    }
  }

  onDefaultPhotoSelect(index) {
    const { selectedPhotos } = this.state

    this.onFormFieldChange('defaultPhotoId', selectedPhotos[index].id, () => {
      this.setState({
        selectedPhotos: selectedPhotos.map((photo, i) => {
          if (photo) {
            photo.isDefault = i === index
          }

          return photo
        })
      })
    })
  }

  onPhotoSelect(selectedPhotos) {
    this.setState({ selectedPhotos }, () => {
      const defaultPhoto = this.state.selectedPhotos.find(photo => photo && photo.isDefault)

      if (!defaultPhoto) {
        this.onFormFieldChange('defaultPhotoId', '')
      }
    })
  }

  onFormFieldChange(id, value, callback) {
    const form = _.set(this.state.form, id, value)

    this.setState({ form }, () => {
      if (callback) {
        callback()
      }
    })
  }

  onSubmit() {
    const photosIds = this.state.selectedPhotos.filter(photo => photo).map(photo => photo.id)

    this.onFormFieldChange('photosIds', photosIds, async () => {
      const {
        createActivity,
        createFlight,
        createInfo,
        createLodging,
        createTransportation,
        updateActivity,
        updateFlight,
        updateInfo,
        updateLodging,
        updateTransportation,
        deleteContentPOI
      } = this.props

      let variables = _.cloneDeep(this.state.form)

      //variables.tripGuruId = this.props.user.id

      if (variables.type == 'Activity' || variables.type == 'Lodging' || variables.type == 'Info') {
        if (this.props.event.eventPois[0].contentPOI) {
          let locationdata = this.props.event.eventPois[0].contentPOI.location;
          let placedata = this.props.event.eventPois[0].contentPOI.place;

          delete locationdata.__typename;
          delete placedata.__typename;
          delete this.props.event.eventPois[0].contentPOI.__typename;

          this.props.event.eventPois[0].contentPOI.location = {data: locationdata};
          this.props.event.eventPois[0].contentPOI.place = {data: placedata};
          
          let contentPOIdata = {data: this.props.event.eventPois[0].contentPOI};

          //variables.contentPOIs = [{contentPoiId: this.props.event.eventPois[0].contentPOI.id, id: this.props.event.eventPois[0].contentPOI.id}]
        }
        else if (variables.contentPOIs){
          if (variables.contentPOIs[0].id) {
            variables.contentPOIs = variables.contentPOIs[0].id
          }
          else {
            // Create the content POI from the data
            let result = await this.props.createPOI({
              variables: { ...variables.contentPOIs[0], defaultPhotoIds: variables.defaultPhotoId, description: variables.description, photosIds: variables.photosIds, tripGuruId: this.props.user.id,workingHours:variables.workingHours }
            })
            variables.contentPOIs = result.data.createContentPOI.id
            //variables.contentPOIs = result.data.insert_contentpoi.returning[0].id
          }
        }
      }
      else {
        // We only handle POI data for the above types
        delete variables.contentPOIs
      }

      if (!variables.defaultPhotoId) {
        delete variables.defaultPhotoId
      }

      let res

      try {
        if (this.props.event) {
          variables.id = this.props.event.id

          if (variables.contentPOIs || variables.eventPois) {
            delete variables.contentPOIs;
            delete variables.eventPois;
          }

          if (variables.eventDetails) {
            var confirmationcode = variables.eventDetails.confirmationCode
            delete variables.eventDetails.confirmationCode;
            var bookedthrough = variables.eventDetails.bookedThrough
            delete variables.eventDetails.bookedThrough;

            delete variables.eventDetails;

            variables.eventDetails = {};

            variables.eventDetails.confirmationcode = confirmationcode;
            variables.eventDetails.bookedthrough = bookedthrough;
            variables.eventDetails.id = this.props.event.EventDetails.id;
          }

          switch (variables.type) {
            case 'Activity':
              res = await updateActivity({ variables })

              break
            case 'Lodging':
              res = await updateLodging({ variables })

              break
            case 'Info':
              res = await updateInfo({ variables })

              break
            case 'CarRental':
            case 'Train':
            case 'Transportation':
              res = await updateTransportation({ variables })

              break
            case 'Flight':
              res = await updateFlight({ variables })
          }
        } else {
          switch (variables.type) {
            case 'Activity':
              res = await createActivity({ variables })

              break
            case 'Lodging':
              res = await createLodging({ variables })

              break
            case 'Info':
              res = await createInfo({ variables })

              break
            case 'CarRental':
            case 'Train':
            case 'Transportation':
              res = await createTransportation({ variables })

              break
            case 'Flight':
              res = await createFlight({ variables })
          }
        }
      } catch (err) {
        NotificationManager.error(err.message, 'Error', 5000)
      }

      if (_.isFunction(this.props.onSave)) {
        const form = this.form.getWrappedInstance()

        let date

        if (this.props.dates[0].dayOfTrip) {
          if (form.state.date) {
            date = this.props.dates.findIndex(d => {
              return d.dayOfTrip === form.state.date.startOf('day').toISOString()
            })
          } else if (form.state.departureDate) {
            date = this.props.dates.findIndex(d => {
              return d.dayOfTrip === form.state.departureDate.startOf('day').toISOString()
            })
          } else if (form.state.checkInDate) {
            date = this.props.dates.findIndex(d => {
              return d.dayOfTrip === form.state.checkInDate.startOf('day').toISOString()
            })
          }
        } else {
          if (form.state.date) {
            date = form.state.date.diff(defaultDate, 'days')
          } else if (form.state.departureDate) {
            date = form.state.departureDate.diff(defaultDate, 'days')
          } else if (form.state.checkInDate) {
            date = form.state.checkInDate.diff(defaultDate, 'days')
          }
        }

        const { dates, initialDay } = this.props

        const event = res.data[Object.keys(res.data)[0]]

        // Check id the date changed to a new day - if so need to link it to another day
        if (date !== initialDay) {
          const oldDay = dates[initialDay]
          const newDay = dates[date]
          await this.props.unlinkEvent ({
            variables: {
              itineraryDayId: oldDay.id,
              contentEventId: event.id
            }
          })
          await this.props.linkEvent ({
            variables: {
              itineraryDayId: newDay.id,
              contentEventId: event.id
            }
          })
        }

        await this.props.onSave(res.data[Object.keys(res.data)[0]], date)
      }
    })
  }

  formatPlaceDetails(details) {
    return geoSuggestToLocation({
      location: details.location,
      placeId: details.place_id,
      description: '',
      gmaps: {
        address_components: details.address_components
      }
    })
  }

  render() {
    const { t, isFluid, dates } = this.props
    const { isSubCategoryVisible, photos, selectedPhotos, place, location, form, additionalInfo, fileName } = this.state

    const containerClassNames = classNames({
      container: !isFluid,
      event: true,
      'container-fluid': isFluid
    })

    return (
      <div className={containerClassNames}>
        <div className="row">
          <div
            className={classNames({
              'col-md-6 col-md-offset-3': !isFluid,
              'col-md-12': isFluid
            })}
          >
            {form.type !== '' &&
              <button className="btn event__submit-btn" onClick={() => this.onSubmit()}>
                {t('save_and_exit')}
              </button>
            }
            <h1>{t('page_title')}</h1>

            <hr />

            <div className="form-horizontal event__form-container">
              <div className="form-group">
                <label htmlFor="type" className="event__form-label col-md-3 control-label">
                  {t('category_label')}
                </label>

                {this.state.isPoi ? (
                  <div className="col-md-9">
                    <select
                      id="type"
                      className="form-control event__form-input"
                      value={this.state.type}
                      onChange={e => this.onCategoryChange(e.target.value)}
                    >
                      <option value="" disabled hidden>
                        {t('category_placeholder')}
                      </option>
                      <option value="Activity">Activity</option>
                      <option value="Lodging">Lodging</option>
                      <option value="Info">Info</option>
                    </select>
                  </div>
                ) : (
                  <div className="col-md-9">
                    <select
                      id="type"
                      className="form-control event__form-input"
                      value={this.state.type}
                      onChange={e => this.onCategoryChange(e.target.value)}
                    >
                      <option value="" disabled hidden>
                        {t('category_placeholder')}
                      </option>
                      <option value="Activity">Activity</option>
                      <option value="Lodging">Lodging</option>
                      <option value="Flight">Flight</option>
                      <option value="TransportationCategory">Transportation</option>
                      <option value="Info">Info</option>
                    </select>
                  </div>
                )}
              </div>

              {isSubCategoryVisible && (
                <div className="form-group">
                  <label htmlFor="sub-category" className="event__form-label col-md-3 control-label">
                    {t('sub_category_label')}
                  </label>
                  <div className="col-md-9">
                    <select
                      id="sub-category"
                      value={this.state.subType}
                      className="form-control event__form-input"
                      onChange={e => this.onCategoryChange(e.target.value, true)}
                    >
                      <option value="TransportationCategory" disabled hidden>
                        {t('sub_category_placeholder')}
                      </option>
                      <option value="CarRental">Rental Car</option>
                      <option value="Train">Rail</option>
                      <option value="Transportation">Other</option>
                    </select>
                  </div>
                </div>
              )}

              <TextInput
                ref={input => (this.titleInput = input)}
                label={t('title_label')}
                labelClass="event__form-label col-md-3 control-label"
                inputWrapperClass="col-md-9"
                wrapperClass="mb-0"
                id="title"
                isGroup={true}
                extraClass="form-control event__form-input"
                placeholder={t('title_placeholder')}
                initialValue={(this.props.POIData && this.props.POIData.title) || form.title}
                validationFuncs={[validateRequired]}
                onChangeExternal={(id, value) => this.onFormFieldChange(id, value)}
              />
            </div>

            <hr />

            {form.type === 'Activity' && (
              <Activity
                form={form}
                dates={dates}
                ref={form => {
                  this.form = form
                }}
                placeInputProps={{
                  value: place,
                  placeholder: t('place_placeholder'),
                  onChange: place => this.onPlaceChange(place)
                }}
                locationInputProps={{
                  value: location,
                  placeholder: t('location_placeholder'),
                  onChange: location => this.onLocationChange(location)
                }}
                onPlaceSelect={(place, placeId) => this.onPlaceSelect(place, placeId)}
                onLocationSelect={(location, placeId) => this.onLocationSelect(location, placeId)}
                onFormFieldChange={(id, value, cb) => this.onFormFieldChange(id, value, cb)}
              />
            )}

            {form.type === 'Lodging' && (
              <Lodging
                form={form}
                ref={form => {
                  this.form = form
                }}
                dates={dates}
                placeInputProps={{
                  value: place,
                  placeholder: t('place_placeholder'),
                  onChange: place => this.onPlaceChange(place)
                }}
                onPlaceSelect={(place, placeId) => this.onPlaceSelect(place, placeId)}
                onFormFieldChange={(id, value, cb) => this.onFormFieldChange(id, value, cb)}
              />
            )}

            {form.type === 'Flight' &&
              !this.state.isPoi && (
                <Flight
                  form={form}
                  ref={form => {
                    this.form = form
                  }}
                  dates={this.props.dates}
                  onFormFieldChange={(id, value, cb) => this.onFormFieldChange(id, value, cb)}
                />
              )}

            {form.type === 'CarRental' &&
              !this.state.isPoi && (
                <CarRental
                  form={form}
                  ref={form => {
                    this.form = form
                  }}
                  dates={this.props.dates}
                  onFormFieldChange={(id, value, cb) => this.onFormFieldChange(id, value, cb)}
                />
              )}

            {form.type === 'Train' &&
              !this.state.isPoi && (
                <Train
                  form={form}
                  ref={form => {
                    this.form = form
                  }}
                  dates={this.props.dates}
                  onFormFieldChange={(id, value, cb) => this.onFormFieldChange(id, value, cb)}
                />
              )}

            {form.type === 'Transportation' &&
              !this.state.isPoi && (
                <Transportation
                  form={form}
                  ref={form => {
                    this.form = form
                  }}
                  dates={this.props.dates}
                  onFormFieldChange={(id, value, cb) => this.onFormFieldChange(id, value, cb)}
                />
              )}

            {form.type === 'Info' && (
              <Info
                form={form}
                ref={form => {
                  this.form = form
                }}
                dates={this.props.dates}
                placeInputProps={{
                  value: place,
                  placeholder: t('place_placeholder'),
                  onChange: place => this.onPlaceChange(place)
                }}
                locationInputProps={{
                  value: location,
                  placeholder: t('location_placeholder'),
                  onChange: location => this.onLocationChange(location)
                }}
                onPlaceSelect={(place, placeId) => this.onPlaceSelect(place, placeId)}
                onLocationSelect={(location, placeId) => this.onLocationSelect(location, placeId)}
                onFormFieldChange={(id, value, cb) => this.onFormFieldChange(id, value, cb)}
              />
            )}

            {!!form.type &&
              form.type !== 'TransportationCategory' && (
                <div>
                  <hr />

                  <PhotoSlider
                    selected={selectedPhotos}
                    photos={photos}
                    label={'Add Photo'}
                    onPhotosAdd={photos => this.setState({ photos })}
                    onDefaultPhotoSelect={photo => this.onDefaultPhotoSelect(photo)}
                    onSelect={selectedPhotos => this.onPhotoSelect(selectedPhotos)}
                  />

                  <hr />

                  <div className="form-horizontal event__form-container">
                    <h2 className="event__form-group-label">{t('file')}</h2>
                    <div className="form-group">
                      <label htmlFor="attachment" className="event__form-label col-md-3 control-label">
                        {t('attachment_label')}
                      </label>
                      <div className="col-md-9">
                        <div
                          className="event__attachment-input"
                          onClick={() => {
                            console.log('input props', this.attachmentInput)
                            this.attachmentInput.click()
                          }}
                        >
                          <input
                            type="text"
                            value={fileName}
                            className="form-control event__form-input event__file-input"
                            placeholder={t('attachment_placeholder')}
                          />
                          {this.state.showFileLoader ? (
                            <img src="/img/rolling.svg" className="icon-attachment" style={{ width: '32px', height: '32px' }} alt="" />
                          ) : (
                            <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon-attachment"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                            >
                              <path d="M10.404 5.11l-1.015-1.014-5.075 5.074c-0.841 0.841-0.841 2.204 0 3.044s2.204 0.841 3.045 0l6.090-6.089c1.402-1.401 1.402-3.673 0-5.074s-3.674-1.402-5.075 0l-6.394 6.393c-0.005 0.005-0.010 0.009-0.014 0.013-1.955 1.955-1.955 5.123 0 7.077s5.123 1.954 7.078 0c0.004-0.004 0.008-0.009 0.013-0.014l0.001 0.001 4.365-4.364-1.015-1.014-4.365 4.363c-0.005 0.004-0.009 0.009-0.013 0.013-1.392 1.392-3.656 1.392-5.048 0s-1.392-3.655 0-5.047c0.005-0.005 0.009-0.009 0.014-0.013l-0.001-0.001 6.395-6.393c0.839-0.84 2.205-0.84 3.045 0s0.839 2.205 0 3.044l-6.090 6.089c-0.28 0.28-0.735 0.28-1.015 0s-0.28-0.735 0-1.014l5.075-5.075z" />
                            </svg>
                          )}
                          {fileName && (
                            <button className="attachment__remove-button btn btn-danger" onClick={e => this.onFileRemove(e)}>
                              <i className="icon-delete" />
                            </button>
                          )}
                        </div>
                        <input
                          type="file"
                          ref={input => {
                            this.attachmentInput = input
                          }}
                          id="attachment"
                          onClick={e => {
                            e.target.value = null
                          }}
                          onChange={e => this.onFileUpload(e)}
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>

                    {!_.isEmpty(additionalInfo) && <hr />}

                    <div>
                      {!_.isEmpty(additionalInfo) &&
                        !!additionalInfo.workingHours && (
                          <div className="additional-info">
                            <h2 className="additional-info__label">Working Hours</h2>
                            <span className="additional-info__value">{additionalInfo.workingHours}</span>
                          </div>
                        )}
                    </div>
                  </div>

                  <button className="btn event__submit-btn" onClick={() => this.onSubmit()}>
                    {t('save_and_exit')}
                  </button>
                </div>
              )}
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  translate('event'),
  graphql(CREATE_POI_QUERY, {
    name: 'createPOI' 
  }),
  graphql(DELETE_FILE_QUERY, {
    name: 'deleteFile'
  }),
  graphql(queries.CREATE_EVENT_ACTIVITY, {
    name: 'createActivity'
  }),
  graphql(queries.CREATE_EVENT_FLIGHT, {
    name: 'createFlight'
  }),
  graphql(queries.CREATE_EVENT_INFO, {
    name: 'createInfo'
  }),
  graphql(queries.CREATE_EVENT_LODGING, {
    name: 'createLodging'
  }),
  graphql(queries.CREATE_EVENT_TRANSPORTATION, {
    name: 'createTransportation'
  }),
  graphql(queries.UPDATE_EVENT_ACTIVITY, {
    name: 'updateActivity'
  }),
  graphql(queries.UPDATE_EVENT_FLIGHT, {
    name: 'updateFlight'
  }),
  graphql(queries.UPDATE_EVENT_INFO, {
    name: 'updateInfo'
  }),
  graphql(queries.UPDATE_EVENT_LODGING, {
    name: 'updateLodging'
  }),
  graphql(queries.UPDATE_EVENT_TRANSPORTATION, {
    name: 'updateTransportation'
  }),
  graphql(queries.DELETE_CONTENT_POI, {
    name: 'deleteContentPOI'
  }),
  graphql(LINK_EVENT, {
    name: 'linkEvent'
  }),
  graphql(UNLINK_EVENT, {
    name: 'unlinkEvent'
  })


)(Event)



// WEBPACK FOOTER //
// src/components/Event/index.js